module.exports = __webpack_public_path__ + "media/images/icons/SVG/050-8eaff295efd8970d056a118a1c0b108c.svg";